// import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';

import { TournamentsService } from './../tournaments/services/tournaments.service';
declare let $;
declare let SetLanguage: any;
@Component({
    selector: 'comp_bettingslip_balance_modal',
    templateUrl: './bettingslip_balance_modal.html',
})
export class BettingSlipBalanceModal implements OnInit {
    public init: boolean;
    constructor(public tournamentsService: TournamentsService) {}
    public ngOnInit() {
        if (this.init) {
            return;
        }
        this.init = true;
    }
    public Balance_Modal_Button_Cancel() {
        $('#BettingSlip_Balance_Modal').modal('hide');
    }
    public Balance_Modal_Button_Info() {
        // $('#BettingSlip_Balance_Info_Modal').modal('show');

        $('#BettingSlip_Balance_Info_Modal')
            .modal({
                allowMultiple: true,
            })
            .modal('show');
    }
}
